import { render } from "./LocaleSelect.vue?vue&type=template&id=1645d40a"
import script from "./LocaleSelect.vue?vue&type=script&lang=js"
export * from "./LocaleSelect.vue?vue&type=script&lang=js"

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"LocaleSelect.vue"]])

export default __exports__